import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  en: {
    translation: {
      // Common
      'loading': 'Loading...',
      'error': 'Error',
      'success': 'Success',
      'cancel': 'Cancel',
      'save': 'Save',
      'edit': 'Edit',
      'delete': 'Delete',
      'view': 'View',
      'add': 'Add',
      'search': 'Search',
      'close': 'Close',

      // Dashboard
      'dashboard': 'Dashboard',
      'totalAdmissionEnquiries': 'Total Admission Enquiries',
      'inProgressEnquiries': 'In-Progress Enquiries',
      'completedEnquiries': 'Completed Enquiries',
      'successRate': 'Success Rate',
      'totalReferralPartners': 'Total Business Partners',
      'totalTeamLeads': 'Total Academic Counsellors',
      'recentActivities': 'Recent Activities',
      'quickActions': 'Quick Actions',
      'addReferralPartner': 'Add Referral Partner',
      'addTeamLead': 'Add Academic Counsellor',

      // Admin Panel
      'referralPartners': 'Business Partners',
      'teamLeads': 'Academic Counsellors',
      'admissionEnquiries': 'Admission Enquiries',
      'universities': 'Universities',
      'countries': 'Countries',
      'banners': 'Banners',
      'aboutContent': 'About Content',
      'gallery': 'Gallery',
      'testimonials': 'Testimonials',
      'blogs': 'Blogs',
      'news': 'News',
      'faq': 'FAQ',
      'features': 'Features',
      'statistics': 'Statistics',
      'generalEnquiries': 'General Enquiries',
      'settings': 'Settings',
      'logout': 'Logout',

      // Forms
      'name': 'Name',
      'email': 'Email',
      'phone': 'Phone',
      'message': 'Message',
      'title': 'Title',
      'description': 'Description',
      'status': 'Status',
      'actions': 'Actions',

      // Messages
      'loggedOutSuccessfully': 'Logged out successfully',
      'loadingDashboard': 'Loading dashboard...',
      'noDataAvailable': 'No data available',
      'searchHere': 'Search Here...',
      'closeSearchPopup': 'Close search popup',
      'submitSearch': 'Submit search',
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;